var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center"},[_c('div',{staticClass:"m-4 p-6 md:w-1/2"},[_c('h2',{staticClass:"text-center"},[_c(_vm.icon,{tag:"component",staticClass:"text-bold mx-auto h-20 w-20 text-gray-300"})],1),_c('br'),_c('h2',{staticClass:"text-center text-2xl font-bold text-gray-300"},[_vm._v(" "+_vm._s(_vm.msg)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }